import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { PageRef } from '@wix/editor-platform-sdk-types'

const MAIN_MENU_ID = 'CUSTOM_MAIN_MENU'
const LINK_TYPES = { DYNAMIC_PAGE_LINK: 'DynamicPageLink' }

const getRouterByPage = async ({
  editorSdkProxy,
  pageRef,
}: {
  editorSdkProxy: EditorSDK
  pageRef: PageRef
}) => {
  const routerRef = await editorSdkProxy.routers.getByPage({ pageRef })
  return editorSdkProxy.routers.get({ routerRef })
}

const addDPLinkToSiteMenu = async ({
  editorSdkProxy,
  pageRef,
  innerRoute,
  label,
}: {
  editorSdkProxy: EditorSDK
  pageRef: PageRef
  innerRoute: string
  label: string
}) => {
  const router = await getRouterByPage({ editorSdkProxy, pageRef })

  return editorSdkProxy.document.menu.addItem({
    menuId: MAIN_MENU_ID,
    menuItem: {
      link: {
        innerRoute,
        routerId: router.id,
        target: '_self',
        type: LINK_TYPES.DYNAMIC_PAGE_LINK,
      },
      label,
    },
  })
}

export default addDPLinkToSiteMenu
